<template>
  <v-expansion-panel-content color="#D8E2F4" class="panel_content">
    <div class="py-2">
      <v-col class="px-2 d-block d-md-flex flex-md-wrap">
        <template v-if="!opened_channels">
          <div class="channels d-flex align-center flex-wrap flex-sm-nowrap px-0 col">

            <img
                v-if="!opened_channels"
                class="triangle"
                :style="{ left: !$vuetify.breakpoint.lgAndUp && '115px' }"
                src="../assets/triangle.svg"
                alt="triangle"
            />

            <img class="avatar-50" v-if="accounts[0]" :src="accounts[0].avatar_url" alt="channel"/>

            <img
                v-if="accounts[1]"
                class="avatar-50 ml-n8"
                :src="accounts[1].avatar_url"
                alt="channel"
            />

            <v-btn
                v-if="accounts.length"
                color="#2C4370"
                width="50"
                height="50"
                class="open_btn ml-n8 "
                outlined
                @click="() => opened_channels = true"
            >
              <img src="../assets/arrow_right.svg" alt="close"/>
            </v-btn>

            <template v-if="selectedAccount">
              <img class="avatar-50 ml-3" :src="selectedAccount.avatar_url" alt="channel"/>
              <span class="ml-3">{{ selectedAccount.name }}</span>
            </template>
          </div>
          <template v-if="selectedAccount">
            <!-- <v-spacer class="d-none d-lg-flex"></v-spacer> -->
            <div class="scroller d-flex ml-md-auto align-center col px-0  col mt-4 mt-md-0">
              <v-slider
                  thumb-color="#2C4370"
                  thumb-size="23px"
                  tick-size="10"
                  :loader-height="10"
                  hide-details=""
                  v-model="scroller_value"
                  track-color="#EEF4FF"
                  track-fill-color="#ACBFE3"
                  :max="scores.followers >= scores.minFollowers ? scores.followers : 0"
                  :min="scores.followers < scores.minFollowers ? 0 : scores.minFollowers"
              >
                <template v-slot:prepend>
                  <v-icon
                      @click="decrement"
                  >
                    mdi-minus
                  </v-icon>
                </template>

                <template v-slot:append>
                  <v-icon
                      @click="increment"
                  >
                    mdi-plus
                  </v-icon>
                </template>
              </v-slider>
            </div>
            <div class="d-flex align-center justify-center ml-md-5 mr-n3 mr-md-5 px-0 col mt-4 mt-md-0">
              <div class="d-flex align-center ml-2 followers-wrap">
                <div class="followers-input d-flex align-center">
                  <img src="../assets/followers.svg" alt=""/>
                  <div class="scroller_value">
                    <v-text-field
                        v-if="scores.followers >= scores.minFollowers"
                        ref="followersInput"
                        type="number"
                        class="v-text-input"
                        v-model="scroller_value"
                        :max="scores.followers >= scores.minFollowers ? scores.followers : 0"
                        :min="scores.followers < scores.minFollowers ? 0 : scores.minFollowers"
                        :step="1"
                        @blur="validateFollowers"
                        @click="startOrder=false"
                    ></v-text-field>
                    <v-text-field
                        v-else
                        ref="followersInput"
                        class="v-text-input"
                        v-model="textNoFollowers"
                        disabled
                    >
                    </v-text-field>
                  </div>
                </div>

                <div class="followers d-flex flex-column align-center justify-center" v-if="accountData">
                  <span>Followers</span> {{ accountData.followed_by_count + scroller_value }}
                </div>
              </div>
            </div>

            <div class="text-center mt-4 my-md-0 align-center col order-followers">
              <template v-if="scores.followers >= scores.minFollowers">
                <v-btn
                    v-if="!startOrder"
                    :disabled="status === 'suspend'"
                    @click="() => startOrder = true"
                    class="order_followers mr-lg-2"
                    dark
                    rounded
                    depressed
                    height="50px"
                    width="201px"
                    color="#76CD68"
                >
                  Order followers
                </v-btn>
                <template v-if="startOrder">
                  <v-btn
                      @click="createOrder"
                      class="order_followers mr-lg-2"
                      style="margin-top:10px"
                      dark
                      rounded
                      depressed
                      height="50px"
                      width="201px"
                      color="#76CD68"
                  >
                    I am sure
                  </v-btn>

                  <v-btn
                      @click="() => startOrder = false"
                      class="order_followers mr-lg-2"
                      style="margin-top:10px"
                      dark
                      rounded
                      depressed
                      outlined
                      height="50px"
                      width="201px"
                      color="#9F4343"
                  >
                    No
                  </v-btn>

                </template>
              </template>
              <template v-else>
                <ModalSelectFollowers
                    v-bind:slug="'instagram'"
                    v-bind:typeProduct="'followers'"
                    v-bind:singleData="singleData"
                />
              </template>
            </div>
          </template>
        </template>
        <template v-if="opened_channels">
          <div class="d-flex align-center flex-wrap col">
            <div
                :class="'channel_item mx-1 ml-lg-0 mr-lg-2 channel_item' + index"
                style="height: 50px;"
                v-for="(channel, index) in accounts"
                :key="index"
            >
              <img
                  class="avatar-50"
                  :src="channel.avatar_url"
                  :alt="channel.name"
                  @click="selectAccount(channel)"
                  @mouseover="openChannelInfo(index)"
              />
              <div class="channel_info">
                {{ channel.name }}
                <img
                    class="channel_triangle"
                    src="../assets/triangle.svg"
                    alt="triangle"
                />
              </div>
            </div>
            <div class="mx-1 ml-lg-0 mr-lg-2">
              <v-btn
                  color="#2C4370"
                  width="50"
                  height="50"
                  class="open_btn ml-lg-n6"
                  outlined
                  @click="() => opened_channels = false"
              >
                <img src="../assets/arrow_left.svg" alt="close"/>
              </v-btn>
            </div>
          </div>
        </template>
      </v-col>
    </div>
  </v-expansion-panel-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { updateCounts } from '../utils/utils';
import vue from 'vue'

import ModalSelectFollowers from '../components/ModalSelectFollowers'
import {showError} from "@/utils/notifications";

export default {
  name: 'CardContent',
  props: ['accounts', 'scores', 'singleData'],
  components: { ModalSelectFollowers },
  data () {
    return {
      selectedAccount: null,
      opened_channels: false,
      scroller_value: 0,
      startOrder: false,
      orderProcessing: false,
    }
  },
  created () {
    this.clearPosts()
    this.clearAccountsData()

    setTimeout(() => {
      if (this.accounts.length) {
        let index = this.$route.fullPath.split('/').pop()
        const parsed = parseInt(index)
        if (isNaN(parsed)) {
          index = 0
        }
        this.selectedAccount = this.accounts[index]
        this.selectAccount(this.accounts[index])
      }
    }, 1000)

  },

  computed: {
    ...mapGetters('accounts', ['accountData']),
    ...mapGetters("user", ["status"]),
    textNoFollowers() {
      return this.scores.followers +  ' min('+ this.scores.minFollowers + ')';
    }
  },

  methods: {
    ...mapActions('accounts', ['loadAccountInstagram', 'loadPostsInstagram', 'clearPosts', 'clearAccountsData']),
    ...mapActions('order', ['createNewOrder']),
    ...mapActions('scores', ['getInstagramStatistic']),
    decrement () {
      this.scroller_value--
    },
    increment () {
      this.scroller_value++
    },
    createOrder () {
      if (this.scores.followers < this.scores.minFollowers) {
          showError('Oops, Minimum order 20 followers. You have low balance.\n' +
              'Go to Home and buy more.')
      }

      if (this.orderProcessing) {return}
      this.orderProcessing = true
      this.createNewOrder({
        id: this.selectedAccount.id,
        serviceId: 3, //instagram followers
        quantity: this.scroller_value
      }).then((data) => {
        console.log(data);
        this.scroller_value = 0
        this.startOrder = false
        this.orderProcessing = false
        this.getInstagramStatistic()
      }).catch(() => {
        this.orderProcessing = false
      })
    },
    validateFollowers (event) {
      const count = updateCounts(event, this.scores.minFollowers, this.scores.followers)
      this.$refs.followersInput.lazyValue = count
      this.$refs.followersInput.initialValue = count
      vue.set(this, 'scroller_value', count)
      event.target.value = count
    },
    selectAccount (account) {
      this.clearPosts()
      this.selectedAccount = account
      this.opened_channels = false
      this.loadAccountInstagram(account.id).then(() => {
        this.loadPostsInstagram()
      })
    },

    openChannelInfo (index) {
      this.closeChannelInfo()
      let el = document.getElementsByClassName('channel_item' + index)[0]
      el.classList.add('open_info')
    },

    closeChannelInfo () {
      let channels = document.getElementsByClassName('channel_item')
      let arr = Array.prototype.slice.call(channels)

      arr.map((channel) => channel.classList.remove('open_info'))
    },
  },
}

</script>
<style scoped>
.panel_content {
  position: relative;
}
>>> .v-input__slot {
  margin-bottom: 3px;
}
>>> .v-input__slot input {
  padding-bottom: 3px;
  padding-top: 0px;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #8b8b8b !important;
}
.avatar-50 {
  width: 50px;
  height: 50px;
  border-radius: 100%;
}

.open_btn {
  border-radius: 50%;
  min-width: 0 !important;
  background: linear-gradient(0deg, #d8e2f4, #d8e2f4);
}

img {
  cursor: pointer;
}

span {
  color: #172745;
  font-size: 14px;
}

.channels {
  position: relative;
}

.triangle {
  position: absolute;
  top: -22px;
  left: 113px;
}

.scroller {
  width: 226px;
}

.scroller >>> .v-slider--horizontal .v-slider__track-container {
  height: 10px !important;
  border-radius: 56px !important;
  overflow: hidden !important;
}

.scroller >>> .v-slider__thumb {
  height: 23px;
  width: 23px;
  border: 3px solid #fff !important;
}

.scroller >>> .v-slider__track-container {
  height: 10px !important;
}

.scroller >>> .v-slider__thumb:before {
  left: -10px;
  top: -9px;
}

.order_followers {
  text-transform: none;
  font-size: 18px;
  font-weight: normal;
}

.scroller_value {
  min-width: 100px;
  color: #172745;
  font-size: 22px;
  line-height: 27px;
  max-width: 110px;
}

.followers {
  color: #687998;
  font-size: 16px;
  line-height: 20px;
}

.channel_item {
  position: relative;
}

.channel_info {
  position: absolute;
  top: -70px;
  left: -10px;
  height: 58px;
  width: 260px;
  display: none;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
  z-index: 100;
}

.open_info .channel_info {
  display: flex;
}

.channel_info a {
  text-decoration: none;
  font-size: 12px;
  color: #2c4370;
}

.channel_triangle {
  position: absolute;
  left: calc(15% - 12px);
  bottom: -10px;
}

.followers-wrap {
  height: 50px;
  background: #EEF4FF;
  border: 1px solid #BFCCE7;
  box-sizing: border-box;
  border-radius: 10px;
}

.followers-input {
  min-width: 132px;
  height: 50px;
  padding: 16px 12px;
}

.followers-input .scroller_value {
  font-family: 'Montserrat', sans-serif;
  margin-left: 10px;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
  color: #172745;
}

.followers {
  width: 96px;
  height: 50px;
  background: #BFCCE7;
  font-family: 'Montserrat', sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #2C4370;
  border-radius: 10px;

}

.followers span {
  font-family: 'Montserrat', sans-serif;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  color: #687998;
}

@media (max-width: 959px) {
  .scroller {
    width: 100%;
  }
}
@media (min-width: 1360px) {
    div.order-followers {
        text-align: right !important
    }
    div.order-followers button {
        margin-right: 0 !important;
    }
}
</style>
